import { render, staticRenderFns } from "./LeadProfileFormWizard.vue?vue&type=template&id=2a87214a&scoped=true"
import script from "./LeadProfileFormWizard.vue?vue&type=script&lang=js"
export * from "./LeadProfileFormWizard.vue?vue&type=script&lang=js"
import style0 from "./LeadProfileFormWizard.vue?vue&type=style&index=0&id=2a87214a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a87214a",
  null
  
)

export default component.exports